import { Controller } from "stimulus"

// Client-side sorting for company lists (no AJAX)
export default class extends Controller {
    static targets = [ "sortBtn", "companiesList", "companyRow" ]
    
    connect() {
       console.log("Companies sort controller connected!")
       this.currentSortField = null
       this.currentSortDirection = 'asc'
    }

    sortBy(event) {
      const sortField = event.currentTarget.dataset.sortField
      const sortBtn = event.currentTarget
      
      // Reset all other buttons first (exclusive sorting)
      this.resetAllSortIcons()
      
      // Toggle sort direction if clicking the same field
      if (this.currentSortField === sortField) {
        this.currentSortDirection = this.currentSortDirection === 'asc' ? 'desc' : 'asc'
      } else {
        this.currentSortDirection = 'asc'
        this.currentSortField = sortField
      }
      
      // Update button icons
      this.updateSortIcons(sortBtn, this.currentSortDirection)
      
      // Sort the companies
      this.sortCompanies(sortField, this.currentSortDirection)
    }
    
    resetAllSortIcons() {
      // Reset all sort icons to neutral state
      this.sortBtnTargets.forEach(btn => {
        const icon = btn.querySelector('i')
        icon.className = 'fa-solid fa-sort text-muted'
        icon.style.fontSize = '1rem'
      })
    }

    updateSortIcons(activeBtn, direction) {
      // Update only the active button icon
      const activeIcon = activeBtn.querySelector('i')
      if (direction === 'asc') {
        activeIcon.className = 'fa-solid fa-sort-up text-primary'
      } else {
        activeIcon.className = 'fa-solid fa-sort-down text-primary'
      }
      activeIcon.style.fontSize = '1rem'
    }
    
    sortCompanies(sortField, direction) {
      // Get all company rows
      const rows = Array.from(this.companyRowTargets)
      
      // Sort the rows based on the field
      rows.sort((a, b) => {
        let valueA = this.getFieldValue(a, sortField)
        let valueB = this.getFieldValue(b, sortField)
        
        // Handle empty values
        if (!valueA && !valueB) return 0
        if (!valueA) return direction === 'asc' ? 1 : -1
        if (!valueB) return direction === 'asc' ? -1 : 1
        
        // Convert to lowercase for case-insensitive comparison
        valueA = valueA.toLowerCase().trim()
        valueB = valueB.toLowerCase().trim()
        
        let comparison = 0
        if (valueA > valueB) {
          comparison = 1
        } else if (valueA < valueB) {
          comparison = -1
        }
        
        return direction === 'asc' ? comparison : -comparison
      })
      
      // Re-append the sorted rows to the container
      const container = this.companiesListTarget
      rows.forEach(row => {
        container.appendChild(row)
      })
    }
    
    getFieldValue(row, field) {
      // Get the value based on the field and the position in the row
      const cells = row.querySelectorAll('p')
      
      switch(field) {
        case 'title':
          // First cell contains the company title (inside link or raw text)
          const titleCell = cells[0]
          const link = titleCell.querySelector('a')
          return link ? link.textContent : titleCell.textContent
        
        case 'ticker':
          // Second cell contains the ticker
          return cells[1] ? cells[1].textContent : ''
        
        case 'sec':
        case 'sector':
          // Third cell contains the sector
          return cells[2] ? cells[2].textContent : ''
        
        case 'country':
        case 'geography':
          // Fourth cell contains the country/geography
          return cells[3] ? cells[3].textContent : ''
        
        default:
          return ''
      }
    }
}